import { useFetchers } from '@remix-run/react'
import { type NodeViewProps } from '@tiptap/core'
import { NodeViewWrapper } from '@tiptap/react'
import { useEffect } from 'react'
import { getCustomizerWidth } from '#app/components/tiptap/hooks/useCustomizer.js'
import { Button } from '#app/components/ui/button.js'
import { StatusButton } from '#app/components/ui/status-button.js'
import { FORM_KEY } from '#app/routes/_public+/$url.($referrer).js'
import { type PUBLIC_FORM } from '#app/utils/constants.js'

export const Component = (props: NodeViewProps) => {
	const { editor, updateAttributes } = props

	const { cta, redirectUrl, redirect, successText, state } = props.node.attrs

	const maxWidth = getCustomizerWidth(props)

	const editable = editor.isEditable

	const fetcher = useFetchers().find(f => f.key === FORM_KEY)

	const data = fetcher?.data as PUBLIC_FORM

	const loading = fetcher?.state && fetcher?.state !== 'idle'

	useEffect(() => {
		if (fetcher?.data && !fetcher?.data.error && redirect) {
			window.parent.location.href = redirectUrl
		}
	}, [fetcher?.data])

	if (editable) {
		return (
			<NodeViewWrapper
				style={{
					width: String(maxWidth) + 'px',
					maxWidth: '100%',
				}}
			>
				<Button className="button-tt w-full">
					{state === 'Idle' && (
						<input
							type="text"
							defaultValue={cta}
							className="w-full appearance-none border-none bg-transparent text-center outline-none"
							onChange={e => {
								updateAttributes({
									cta: String(e.target.value),
								})
							}}
						/>
					)}
					{state === 'Success' && (
						<input
							type="text"
							defaultValue={successText}
							className="w-full appearance-none border-none bg-transparent text-center outline-none"
							onChange={e => {
								updateAttributes({
									successText: String(e.target.value),
								})
							}}
						/>
					)}
				</Button>
			</NodeViewWrapper>
		)
	} else {
		return (
			<NodeViewWrapper
				style={{
					width: String(maxWidth) + 'px',
					maxWidth: '100%',
				}}
			>
				<StatusButton
					className="button-tt w-full"
					type="submit"
					status={loading ? 'pending' : 'idle'}
					disabled={loading}
				>
					{data?.errors?.general
						? data?.errors?.general
						: data && !redirect
							? successText
							: cta}
				</StatusButton>
			</NodeViewWrapper>
		)
	}
}

export default Component
